import { Reveal, SectionHead } from "./Reveal";
import { SERVICE_HIGHLIGHTS } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

const ServiceHighlights = () => (
    <section id="services" className="py-24 sm:py-32">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <SectionHead
                eyebrow="What We Do"
                title="Key Service Highlights"
                sub="Ten compliance domains, one accountable partner. Every engagement is documented, dated and tracked."
            />
            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10" data-testid="service-highlights-grid">
                {SERVICE_HIGHLIGHTS.map((s, i) => (
                    <Reveal key={s.title} delay={(i % 3) * 0.08} className="bg-[#0A1128]">
                        <a
                            href="#registration-services"
                            data-testid={`service-card-${i + 1}`}
                            className="group block h-full p-7 sm:p-8 hover:bg-[#101D3F] transition-colors duration-300"
                        >
                            <div className="flex items-start justify-between">
                                <span className="font-mono2 text-xs text-sky-500 tracking-widest">{String(i + 1).padStart(2, "0")}</span>
                                <ArrowUpRight size={16} className="text-slate-600 group-hover:text-sky-400 transition-colors duration-300" />
                            </div>
                            <h3 className="mt-6 font-heading text-lg font-semibold text-white leading-snug">{s.title}</h3>
                            <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                        </a>
                    </Reveal>
                ))}
                <Reveal delay={0.16} className="bg-[#0A1128]">
                    <a
                        href="#contact"
                        data-testid="service-card-cta"
                        className="group flex h-full flex-col justify-between p-7 sm:p-8 bg-gradient-to-br from-blue-700/40 to-cyan-600/10 hover:from-blue-700/60 transition-colors duration-300"
                    >
                        <span className="font-mono2 text-xs text-sky-300 tracking-widest">CTA</span>
                        <div>
                            <h3 className="mt-6 font-heading text-lg font-semibold text-white leading-snug">Not sure what applies to you?</h3>
                            <p className="mt-3 text-sm text-slate-300 leading-relaxed">Get a compliance applicability assessment for your business.</p>
                            <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-sky-300">
                                Get Compliance Assistance <ArrowUpRight size={15} />
                            </span>
                        </div>
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);

export default ServiceHighlights;
